import React, {useEffect, useState } from 'react';
import {FIELD_DETAILS, TITLE, TRANSFORMATION_NAME } from '../ISRConstants';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput, TTransformation } from '../Pages/DefineModel/model';

type TTransformationComponentProps = {
    id: string;
    subSelectedItem: TTransformation|null;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null ;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    indexInfo: TIndexState;
    createISRProject:()=>void
}

const TransformationComponent = ({id, subSelectedItem, selectedItem, setUserProjectDataModels, userProjectDataModels, indexInfo, createISRProject}: TTransformationComponentProps) => {
    const [fieldName, setFieldName] = useState<string>('');

    useEffect(() => {
        const productCategory = selectedItem as TProductCategory;
        if (productCategory?.data?.belongsToDataModel) {
            setFieldName(userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.data?.productCategories[indexInfo?.categoryIndex ?? -1]?.data?.transformations[indexInfo?.TransformationIndex ?? -1]?.name ?? "");
        } else {
            setFieldName(userProjectDataModels?.project.productCategories[indexInfo?.categoryOutsideDataModelIndex ?? -1]?.data?.transformations[indexInfo?.TransformationIndex ?? -1]?.name ?? "");
        }
    }, [selectedItem, subSelectedItem]);

    const handleTransformationNameChange = (value: string) => {
        setFieldName(value);
        updateFieldName(value);
    };

    const updateFieldName = (fieldName: string) => {
        const productCategory = selectedItem as TProductCategory;
        setUserProjectDataModels((prevDataModels) => {
            const newDataModels = { ...prevDataModels };
            if (productCategory && productCategory?.data?.belongsToDataModel) {
                const dataModelToUpdate = newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
                if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.productCategories[indexInfo?.categoryIndex ?? -1]) {
                    dataModelToUpdate.data.productCategories[indexInfo.categoryIndex ?? -1].data.transformations[indexInfo.TransformationIndex??-1].name = fieldName;

                }
                newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1] = dataModelToUpdate
            } else {
                const fieldToUpdate = newDataModels.project.productCategories[indexInfo?.fieldOutsideDataModelIndex ?? -1];
                if (fieldToUpdate && fieldToUpdate.data && fieldToUpdate.data?.transformations[indexInfo.TransformationIndex??-1] ) {
                    fieldToUpdate.data.transformations[indexInfo.TransformationIndex??-1].name = fieldName;
                }
                newDataModels.project.productCategories[indexInfo?.fieldOutsideDataModelIndex ?? -1] = fieldToUpdate
            }
        return newDataModels;});
        createISRProject()
    };

    return (
        <div id={`${id}`} className='cart-style-dm'>
            <label id={`${id}-title`} className='cart-title'>{FIELD_DETAILS}</label>
            <div id={`${id}-content`} className='tw-flex tw-items-center tw-mt-3'>
                <div id={`${id}-input-container`} className='tw-w-[60%] tw-pe-2'>
                    <label 
                        id={`${id}-input-label`} 
                        className='tw-text-sm tw-text-[#747593] tw-block'
                    >
                        {TITLE}
                        <span 
                            id={`${id}-required-indicator`} 
                            className="tw-text-red-500 tw-ml-4"
                        >
                            *
                        </span>
                    </label>
                    <input 
                        id={`${id}-input`}
                        className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        value={fieldName}
                        onChange={(e) => handleTransformationNameChange(e.target.value)}
                        placeholder={TRANSFORMATION_NAME} 
                    />
                </div>
            </div>
        </div>
    );
}

export default TransformationComponent;